import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import JobCard from './JobCard';

function SortableJobCard({ job, orderNumber, isEditMode }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: job.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: 'none',
  };

  const handleClick = (e) => {
    // Always block navigation in edit mode
    if (isEditMode) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      onClickCapture={handleClick}
      className="cursor-grab active:cursor-grabbing"
    >
      <JobCard job={job} orderNumber={orderNumber} isDragging={isDragging} blockNavigation={isEditMode} />
    </div>
  );
}

export default SortableJobCard;
